import { ComponentMap } from '@cinch-nx/data-storyblok'
import { CarsCarouselSection } from '@cinch-nx/landing-ui-shared'

import {
  HelpMeChoose,
  HomeHeroV2,
  PartExchangeSection,
  UspSlide,
  ValuePropositions,
  WhyCinch,
} from '../components'

export const storyblokComponents: ComponentMap = {
  HomeHeroV2: HomeHeroV2,
  HelpMeChooseSection: HelpMeChoose,
  WhyCinchSection: WhyCinch,
  PartExSection: PartExchangeSection,
  ValuePropsCard: ValuePropositions,
  HomeUspSlide: UspSlide,
  CarsCarouselSection: CarsCarouselSection,
}
